export const MECHANIC_APP_SALES_REP = 17;

export const MECHANIC_TIERS = new Map([
  ["gold", "عميل ذهبي"],
  ["silver", "عميل سيلفر"],
  ["bronze", "عميل برونز"],
]);
